const TOUR_RESUME_BUTTON_ID = 'hdv-tour-resume-btn'

export const mountTourResumeButton = (onResume) => {
    let resumeButton = document.getElementById(TOUR_RESUME_BUTTON_ID)

    if (!resumeButton) {
        resumeButton = document.createElement('button')
        resumeButton.id = TOUR_RESUME_BUTTON_ID
        resumeButton.type = 'button'
        resumeButton.textContent = 'Retomar guia'
        document.body.appendChild(resumeButton)
    }

    resumeButton.onclick = () => {
        if (typeof onResume === 'function') onResume()
    }

    return resumeButton
}

export const setTourResumeVisible = (visible) => {
    const resumeButton = document.getElementById(TOUR_RESUME_BUTTON_ID)
    if (!resumeButton) return

    resumeButton.classList.toggle('is-visible', Boolean(visible))
}

export const unmountTourResumeButton = () => {
    document.getElementById(TOUR_RESUME_BUTTON_ID)?.remove()
}
